import { render, staticRenderFns } from "./OurCentersComponent.vue?vue&type=template&id=188cf9e6&"
import script from "./OurCentersComponent.vue?vue&type=script&lang=js&"
export * from "./OurCentersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports